import {
  TMajorMetric,
} from '@bingads-webui-campaign-react/overview-performance-table';

import { TDataRequestSortDirection } from './types';

export function getOrderFromGridSortForCombinedCall({
  sortColumn,
  sortDirection,
  dateRange,
  comparisonMajorMetric,
}: {
  sortColumn: string | number;
  sortDirection: 'ascending' | 'descending';
  dateRange: any;
  comparisonMajorMetric: TMajorMetric;
}) : {
  sortColumn: string;
  sortDirection: TDataRequestSortDirection;
} {
  const order = sortDirection === 'ascending' ? 'ASC' : 'DESC';
  let orderByValue;

  if (dateRange.compared) {
    switch (comparisonMajorMetric) {
      case 'PerformanceMetricsChange':
        orderByValue = 'PoPPerformanceMetricsChange';
        break;
      case 'PerformanceMetricsChangePercentage':
        orderByValue = 'PoPPerformanceMetricsChangePercentage';
        break;
      case 'PerformanceMetrics':
        orderByValue = 'PerformanceMetrics';
        break;
      default:
        orderByValue = 'PerformanceMetrics';
        break;
    }
  } else {
    orderByValue = 'PerformanceMetrics';
  }

  return {
    sortColumn: `${orderByValue}/${sortColumn}`,
    sortDirection: order,
  };
}

export function getOrderFromGridSort({
  sortColumn,
  sortDirection,
  dateRange,
  comparisonMajorMetric,
}: {
  sortColumn: string | number;
  sortDirection: 'ascending' | 'descending';
  dateRange: any;
  comparisonMajorMetric: TMajorMetric;
}) : {
  orderby: string | number;
  direction: number;
} {
  const direction = sortDirection === 'ascending' ? 1 : -1;
  let orderByValue;

  if (dateRange.compared) {
    switch (comparisonMajorMetric) {
      case 'PerformanceMetricsChange':
        orderByValue = 'PoPPerformanceMetricsChange';
        break;
      case 'PerformanceMetricsChangePercentage':
        orderByValue = 'PoPPerformanceMetricsChangePercentage';
        break;
      case 'PerformanceMetrics':
        orderByValue = 'PerformanceMetrics';
        break;
      default:
        orderByValue = 'PerformanceMetrics';
        break;
    }
  } else {
    orderByValue = 'PerformanceMetrics';
  }

  return {
    orderby: sortColumn,
    direction,
  };
}
